import React, {Component} from 'react'
import './assets-static/stylesheets/theme.css';
import {connect} from "react-redux";
import {loadApplicationData, saveApplicationData} from "./actions/ApplicationAction";
        import EQ_1_1 from "./components/EQ-1.1";
        import EQ_1_3 from "./components/EQ-1.3";
        import EQ_1_5 from "./components/EQ-1.5";
        import EQ_1_6 from "./components/EQ-1.6";
        import EQ_1_7_1 from "./components/EQ-1.7.1";
        import EQ_1_7_2 from "./components/EQ-1.7.2";
        import EQ_1_7_3 from "./components/EQ-1.7.3";
    import { BrowserRouter, Route, Switch } from 'react-router-dom';

class EQ extends Component {
constructor(props) {
super(props);
}

render() {
return (
<div>
    {this.props.application != undefined && this.props.application.applicationData != undefined &&
        <BrowserRouter>
            <Switch>
                                                            <Route path="/imm5444epremium/interactions/eq/users/0/applications/0/pages/EQ-1.1">
                            <EQ_1_1 />
                        </Route>
                                            <Route path="/imm5444epremium/interactions/eq/users/0/applications/0/pages/EQ-1.3">
                            <EQ_1_3 />
                        </Route>
                                            <Route path="/imm5444epremium/interactions/eq/users/0/applications/0/pages/EQ-1.5">
                            <EQ_1_5 />
                        </Route>
                                            <Route path="/imm5444epremium/interactions/eq/users/0/applications/0/pages/EQ-1.6">
                            <EQ_1_6 />
                        </Route>
                                            <Route path="/imm5444epremium/interactions/eq/users/0/applications/0/pages/EQ-1.7.1">
                            <EQ_1_7_1 />
                        </Route>
                                            <Route path="/imm5444epremium/interactions/eq/users/0/applications/0/pages/EQ-1.7.2">
                            <EQ_1_7_2 />
                        </Route>
                                            <Route path="/imm5444epremium/interactions/eq/users/0/applications/0/pages/EQ-1.7.3">
                            <EQ_1_7_3 />
                        </Route>
                                                </Switch>
        </BrowserRouter>
    }
</div>)
}
}

const mapDispatchToProps = (dispatch) => {
loadApplicationData("imm5444epremium").then((data) => {
return {
application: dispatch(data).payload
}
})
return dispatch(saveApplicationData({}))
};

const mapStateToProps = state => {
return {
application: state.application
}
};

export default connect(mapStateToProps, mapDispatchToProps)(EQ)
